import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,IconButton,  Menu,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { useAuth } from "../../../../../AuthProvider";
import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from "@mui/icons-material/PresentToAll";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useParams } from "react-router-dom";
import { ToastContainer,toast  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const Unit1ExaminationResultList = () => {
  const { Examtype } = useParams();
  const navigate = useNavigate();
  const { oId,board ,userId,role,pId} = useAuth();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [pieChartData, setPieChartData] = useState({});
  const [loading, setLoading] = useState(true);
  const [totalMarks, setTotalMarks] = useState([]);
                      const [tableDataLoaded, setTableDataLoaded] = useState(false);
                      //SSC
                      const [sscClassOptions, setSscClassOptions] = useState([]);
                      const [sscSectionOptions, setSscSectionOptions] = useState([]);
                      const [sscSelectedClass, setSscSelectedClass] = useState("");
                      const [sscSelectedSection, setSscSelectedSection] = useState("");
                     
                      // INTERMEDIATE states
                      const [interSectionOptions, setInterSectionOptions] = useState([]);
                      const [interSelectedClass, setInterSelectedClass] = useState("Inter-1st-Year");
                      const [interSelectedSection, setInterSelectedSection] = useState("");
                      const [courseOptions, setCourseOptions] = useState([]);
                      const [selectedCourseType, setSelectedCourseType] = useState("");
                       const [sscClassSectionMap, setSscClassSectionMap] = useState({});
   const [exportAnchorEl, setExportAnchorEl] = useState(null);
   const isExportMenuOpen = Boolean(exportAnchorEl);
   const handleExportClick = (event) => {
     setExportAnchorEl(event.currentTarget);
   };
 
   const handleExportClose = () => {
     setExportAnchorEl(null);
   };
const [btnloading, setbtnLoading] = useState(false);
     const [data, setData] = useState(null);

const handleClick = async () => {
    setbtnLoading(true);
  try {
    const response = await fetch(`${baseUrl}/api/markSheet/result/principal/${pId}?examType=${Examtype}`);
    
    if (!response.ok) {
      throw new Error("Failed to release results");
    }
    const result = await response.json();
    if (!result || (Array.isArray(result) && result.length === 0)) {
      toast.info("Results not yet released");
      return;
    }
toast.success("Results released successfully", {
  autoClose: 2000, // 2 seconds
});
  } catch (error) {
    console.error("Error fetching data:", error);
    toast.error("Failed to release results", {
  autoClose: 2000, // 2 seconds
});
  }finally {
    setbtnLoading(false); // stop loader
  }
};
                          //           For SSC functions
                          // -------------------------------------------
                         
                          // ---- Fetch Class + Sections for SSC (School) ----
                          const fetchClassRegistrationData = async () => {
  try {
    const response = await fetch(
      `${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`
    );
    const data = await response.json();

    if (response.ok && Array.isArray(data)) {
      const classSectionMap = {};

      data.forEach((item) => {
        const className = item.classRegistration;
        const sections = item.sections.split(",").map((s) => s.trim());

        if (!classSectionMap[className]) {
          classSectionMap[className] = new Set();
        }
        sections.forEach((sec) => classSectionMap[className].add(sec));
      });
      const classes = Object.keys(classSectionMap);
      setSscClassOptions(classes);
      setSscClassSectionMap(classSectionMap);

      if (classes.length) {
        const defaultClass = classes[0];
        const sectionArray = [...classSectionMap[defaultClass]];
        setSscSelectedClass(defaultClass);
        setSscSectionOptions(sectionArray);
        setSscSelectedSection(sectionArray[0] || ""); // ✅ Select first section
      } else {
        setSscSelectedClass("");
        setSscSectionOptions([]);
        setSscSelectedSection("");
      }
    }
  } catch (error) {
    console.error("Error fetching SSC data:", error);
  }
};
                                                        // ---- Fetch Table Data for SSC ----
                                                          const fetchClassSectionTableData = async () => {
                                                            if (!sscSelectedClass || !sscSelectedSection) {
                                                              setFilteredData([]);
                                                              setTotalMarks(0);
                                                              setTableDataLoaded(false);
                                                              setLoading(false);
                                                              return;
                                                            }
                                                            setLoading(true);
                                                            setTableDataLoaded(false);
                                                            try {
                                                              const response = await fetch(
                                                             
                                                                // `${baseUrl}/api/markSheet/getAllStudentOverallMarks/${oId}/${pId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&type=${Examtype}`
                                                              `${baseUrl}/api/subjectMarks/verifyStudentResult/${oId}/${pId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&examType=${Examtype}`
                                                               
                                                              );
                                                              const data = await response.json();
                                                              if (Array.isArray(data)) {
                                             
                                                                setFilteredData(data);
                                                                setTotalMarks(data[0].totalMarks);
                                                                setTableDataLoaded(true);
                                                                // setUniqueCourseType([...new Set(data.map(item => item.course))]);
                                                              } else {
                                                                setFilteredData([]);
                                                                setTotalMarks(0);
                                                                setTableDataLoaded(false);
                                                              }
                                                            } catch (error) {
                                                              console.error("Error fetching SSC table data:", error);
                                                              setTableDataLoaded(false);
                                                            } finally {
                                                              setLoading(false);
                                                            }
                                                          };
                                                         
                                                          //-------Fetch Pie Data for SSC--------
                                                          useEffect(() => {
                                                                       if (board !== "SSC" || !sscSelectedClass ||
                                                                         !sscSelectedSection || !totalMarks ||
                                                                         !tableDataLoaded
                                                         
                                                                       ) return;
                                                                     
                                                                       const fetchSSCData = async () => {
                                                                         try {
                                                                           const response = await fetch(
                                                                           
                                                                             `${baseUrl}/api/markSheet/reportPassFailPercentage/${oId}/${pId}?romanNumberClass=${sscSelectedClass}&sections=${sscSelectedSection}&type=${Examtype}&totalMarks=${totalMarks}`
                                                                           );
                                                                           const data = await response.json();
                                                                           setPieChartData(data);
                                                                           
                                                                         } catch (error) {
                                                                           console.error("Error fetching SSC pie chart data:", error);
                                                                         }
                                                                       };
                                                                     
                                                                       fetchSSCData();
                                                          }, [board, sscSelectedClass, sscSelectedSection,totalMarks, tableDataLoaded]);
                    // -------------------------------------------
                    //           For Intermediate functions
                    // -------------------------------------------
                   
                    // ---- Fetch Courses for INTERMEDIATE ----
                    const fetchCourseData = async () => {
                      if(!interSelectedClass) return;
                      try {
                        const response = await fetch(`${baseUrl}/api/dynamic-classReg/getAllcoursesAccordingClasses/${pId}?romanNumberClass=${interSelectedClass}`);
                        const data = await response.json();
                        if (response.ok && Array.isArray(data)) {
                          setCourseOptions(data);
                          if (!selectedCourseType) {
                            setSelectedCourseType(data[0] || "");
                          }
                        } else {
                          setCourseOptions([]);
                        }
                      } catch (error) {
                        console.error("Error fetching course data:", error);
                        setCourseOptions([]);
                      }
                    };
                   
                    // ---- Fetch Sections for INTERMEDIATE ----
                    const fetchSectionsData = async () => {
                      if (!interSelectedClass || !selectedCourseType) {
                        setInterSectionOptions([]);
                        return;
                      }
                      try {
                        const response = await fetch(
                          `${baseUrl}/api/dynamic-classReg/getAllClass-registrations/${interSelectedClass}/${selectedCourseType}/${pId}`
                        );
                        const data = await response.json();
                        if (response.ok && Array.isArray(data) && data.length > 0) {
                          const sectionsString = data[0].sections;  // because your data is like [{ sections: "Section-A,Section-B" }]
                          const sections = sectionsString.split(",").map(section => section.trim());
                         
                          setInterSectionOptions(sections);
                   
                          if (sections.length > 0) {
                            setInterSelectedSection(sections[0]);
                          } else {
                            setInterSelectedSection("");
                          }
                        } else {
                          setInterSectionOptions([]);
                          setInterSelectedSection("");
                        }
                      } catch (error) {
                        console.error("Error fetching INTERMEDIATE data:", error);
                      }
                    };
                    // ---- Fetch Table Data for INTERMEDIATE ----
                    const fetchCourseClassSectionTableData = async () => {
                      if (!selectedCourseType || !interSelectedClass || !interSelectedSection) {
                        setFilteredData([]);
                        setTotalMarks(0);
                        setTableDataLoaded(false);
                        setLoading(false);
                        return;
                      }
                      setLoading(true);
                      setTableDataLoaded(false);
                      try {
                        const response = await fetch(
                          `${baseUrl}/api/markSheet/getAllStudentOverallMarks/${oId}/${pId}?romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&type=${Examtype}&course=${selectedCourseType}`
       
                        );
                        const data = await response.json();
                        if (Array.isArray(data)) {
                         
                          setFilteredData(data);
                          setTotalMarks(data[0].totalMarks);
                          setTableDataLoaded(true);
                          // setUniqueCourseType([...new Set(data.map(item => item.course))]);
                        } else {
                         
                          setFilteredData([]);
                          setTotalMarks(0);
                          setTableDataLoaded(false);
                        }
                      } catch (error) {
                        console.error("Error fetching INTERMEDIATE table data:", error);
                        setTableDataLoaded(false);
                      } finally {
                        setLoading(false);
                      }
                    };
       
                    //------ Fetch Pie Data for INTERMEDIATE---------
                    useEffect(() => {
                     if (
                       board !== "INTERMEDIATE" ||
                       !interSelectedClass ||
                       !interSelectedSection ||
                       !selectedCourseType ||
                       !totalMarks ||
                       !tableDataLoaded
                     ) return;
                   
                     const fetchIntermediatePieChart = async () => {
                       try {
                         const response = await fetch(
                           `${baseUrl}/api/markSheet/reportPassFailPercentage/${oId}/${pId}?romanNumberClass=${interSelectedClass}&sections=${interSelectedSection}&type=${Examtype}&totalMarks=${totalMarks}&course=${selectedCourseType}`
                         );
                         const data = await response.json();
                         setPieChartData(data);
                       
                       } catch (error) {
                         console.error("Error fetching Intermediate pie chart data:", error);
                       }
                     };
                   
                     fetchIntermediatePieChart();
                   }, [board, interSelectedClass, interSelectedSection, selectedCourseType, totalMarks, tableDataLoaded]);

                    useEffect(() => {
                      const loadClassData = async () => {
                        if (board === "INTERMEDIATE") {
                          await fetchSectionsData();
                        } else if (board === "SSC") {
                          await fetchClassRegistrationData();
                        }
                      };
                      loadClassData();
                    }, [board,interSelectedClass, selectedCourseType, oId]); 
                    // Fetch course options if board is INTERMEDIATE
                    useEffect(() => {
                      if (board === "INTERMEDIATE") {
                        fetchCourseData();
                      }
                    }, [interSelectedClass,board, oId]);
                   
                    // Fetch Table Data whenever filters change
                    useEffect(() => {
                      if (board === "SSC") {
                        if (!sscSelectedClass || !sscSelectedSection) {
                       
                          setFilteredData([]);
                          setLoading(false); // ✅ stop loading even if API not called
                          return;
                        }
                        fetchClassSectionTableData(); // Modify inside function to use sscSelectedClass and sscSelectedSection
                      } else if (board === "INTERMEDIATE") {
                        if (!interSelectedClass || !interSelectedSection || !selectedCourseType) {
                       
                          setFilteredData([]);
                         
                          setLoading(false); // ✅ same here
                          return;
                        }
                        fetchCourseClassSectionTableData(); // Modify inside function to use interSelectedClass and interSelectedSection
                      }
                    }, [board, sscSelectedClass, sscSelectedSection, interSelectedClass, interSelectedSection, selectedCourseType]);
     
// Filter data based on searchQuery
const filteredResults = filteredData.filter((item) => {
  const firstName = item.firstName ? item.firstName.toLowerCase() : "";
  const lastName = item.lastName ? item.lastName.toLowerCase() : "";
  const fullName = `${firstName} ${lastName}`; // Combine first and last names
  return fullName.includes(searchQuery.toLowerCase()); // Search in full name
});
const passPercentage = Math.round(pieChartData.passPercentage);
const failPercentage = Math.round(pieChartData.failPercentage);
const pieData = [
  { name: "Pass", value: passPercentage, color: "#4CAF50" }, // Green
  { name: "Fail", value: failPercentage, color: "#F44336" } // Red
];
const exportToExcel = () => {
  const isIntermediate = board === "INTERMEDIATE";
    const dynamicKey = isIntermediate ? "Year" : "Class";

  const processedData = filteredData.map(
    ({
      studentId,
      course,
      romanNumberClass,
      sections,
      firstName,
      lastName,
      obtainedMarks,
      overallGrade,
      totalMarks,
      type
    }) => ({
      StudentID: studentId,
      ...(isIntermediate ? { Course: course } : {}),
        [dynamicKey]: romanNumberClass,
      Section: sections,
      StudentName: `${firstName} ${lastName}`,
      Marks: obtainedMarks,
      Grade: overallGrade,
      TotalMarks: totalMarks,
      ExamType: type
    })
  );

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(
      board === "INTERMEDIATE"
        ? `${interSelectedClass}-${interSelectedSection}_${Examtype}_ResultsList`
        : `${sscSelectedClass}-${sscSelectedSection}_${Examtype}_ResultsList`
    );

    worksheet.columns = [
      { header: "Student ID", key: "StudentID", width: 20 },
      
      { header: "Student Name", key: "StudentName", width: 25 },
      ...(board === "INTERMEDIATE"
        ? [{ header: "Course", key: "Course", width: 15 }]
        : []),
      { header: isIntermediate ? "Year" : "Class", key: dynamicKey, width: 15 },
      { header: "Section", key: "Section", width: 15 },
       { header: "Exam Type", key: "ExamType", width: 15 },
       { header: "Total Marks", key: "TotalMarks", width: 15 },
      { header: "Obtained Marks", key: "Marks", width: 15 },
      { header: "Grade", key: "Grade", width: 10 },
    ];
   
    // Add data to worksheet
    processedData.forEach((data) => {
      worksheet.addRow(data);
    });

    // Style headers
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" }, // Light Blue Header
      };
    });

    // Write and download file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
   
    link.download = board === "INTERMEDIATE"
    ? `${interSelectedClass}-${interSelectedSection}_${Examtype}_ResultsList.xlsx`
    : `${sscSelectedClass}-${sscSelectedSection}_${Examtype}_ResultsList.xlsx`;

      link.click();
    });
    handleExportClose();
  };

  // Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();
 
    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    if(board === "INTERMEDIATE") {
      doc.text(`${interSelectedClass}-${interSelectedSection}_Results  List`, 10, 8);
    } else {
      doc.text(`${sscSelectedClass}-${sscSelectedSection}_Results  List`, 10, 8);
    }
 
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Generated On: ", 14, 16);
    doc.setFont("helvetica", "bold");
    doc.text(new Date().toLocaleDateString(), 40, 16);
 
    // Define headers dynamically
    const headers = board === "INTERMEDIATE"
      ? [
        "S.No",
        "Student ID",
        "Student Name",
        "Course",
        "Year",
        "Section",
        
        "Marks",
        "Grade",
        "Total Marks",
       
        ]
      : [
        "S.No",
        "Student ID",
       "Student Name",
        "Class",
        "Section",
        "Total Marks",
        "Obtaioned Marks",
        "Grade",
        
       
        ];
 
    // Define body dynamically
    const bodyData = filteredData.map((row, index) => {
      const baseData = [
        index + 1,
        row.studentId,
        `${row.firstName} ${row.lastName}`,
      ];
 
      if (board === "INTERMEDIATE") {
        baseData.push(row.course); // Add course if INTERMEDIATE
      }
 
      baseData.push(
        `${row.romanNumberClass}`,
        row.sections,
       row.totalMarks,
        row.obtainedMarks,
        row.overallGrade,
      );
 
      return baseData;
    });
 
    // Table
    doc.autoTable({
      startY: 20,
      head: [headers],
      body: bodyData,
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181], // Dark Blue Header
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });
    if(board === "INTERMEDIATE") {
      doc.save(`${interSelectedClass}-${interSelectedSection}_${Examtype}_ResultsList.pdf`);
    } else {
      doc.save(`${sscSelectedClass}-${sscSelectedSection}_${Examtype}_ResultsList.pdf`);
    }
   
    handleExportClose();
  };
 
  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredData, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    if(board === "INTERMEDIATE") {
      link.download = `${interSelectedClass}-${interSelectedSection}_${Examtype}_ResultsList.json`;
    } else {
      link.download = `${sscSelectedClass}_${sscSelectedSection}_${Examtype}_ResultsList.json`;
    }
    // link.download = `${selectedClass}-${selectedSection}_StudentsList.json`;
    link.click();
    handleExportClose();
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop:"60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
<Box
  display="flex"
  alignItems="center"
  justifyContent="space-between"
  sx={{ marginBottom: 2 }}
>
  {/* Left side: Back button + heading */}
  <Box display="flex" alignItems="center">
    <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>
    <Typography
      variant="h5"
      component="h3"
      sx={{ fontWeight: 'bold' }}
    >
      {Examtype} Examination Results
    </Typography>
  </Box>
  <Button
  variant="contained"
  color="primary"
  onClick={handleClick}
  style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
  disabled={btnloading} // disable while loading
>
   <Box display="flex" alignItems="center" gap={1}>
    {btnloading && <CircularProgress size={20} sx={{ color: "white" }} />}
    <span style={{ color: "white" }}>
      {btnloading ? "Publishing..." : `Publish ${Examtype} Results`}
    </span>
  </Box>
</Button>
</Box>
          <Box
  display="flex"
 
  mb={3}
  flexWrap="wrap"
>
 
 {board === "SSC" && (
                 <>
                   <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                     <InputLabel id="class-select-label">Select Class</InputLabel>
                     <Select
                       labelId="class-select-label"
                       value={sscSelectedClass}
                        onChange={(e) => {
          const selected = e.target.value;
          setSscSelectedClass(selected);
          // setMode("classSection");
      
          const sections = sscClassSectionMap[selected] ? Array.from(sscClassSectionMap[selected]) : [];
          setSscSectionOptions(sections);
          setSscSelectedSection(sections.includes("Section-A") ? "Section-A" : sections[0] || "");
        }}
        
                       label="Select Class"
                       sx={{ height: 35 }}
                     >
                       {sscClassOptions.map((cls) => (
                         <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                       ))}
                     </Select>
                   </FormControl>
               
                   <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                     <InputLabel id="section-select-label">Select Section</InputLabel>
                     <Select
                       labelId="section-select-label"
                       value={sscSelectedSection}
                       onChange={(e) => setSscSelectedSection(e.target.value)}
                       label="Select Section"
                       sx={{ height: 35 }}
                       disabled={sscSectionOptions.length === 0}
                     >
                       {sscSectionOptions.map((section) => (
                         <MenuItem key={section} value={section}>{section}</MenuItem>
                       ))}
                     </Select>
                   </FormControl>
                 </>
               )}
               
               {board === "INTERMEDIATE" && (
                 <>
                   <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                     <InputLabel id="intermediate-class-select-label">Select Year</InputLabel>
                     <Select
                       labelId="intermediate-class-select-label"
                       value={interSelectedClass}
                       onChange={(e) => setInterSelectedClass(e.target.value)}
                       label="Select Year"
                       sx={{ height: 35 }}
                     >
                       <MenuItem value="Inter-1st-Year">Inter-1st-Year</MenuItem>
                       <MenuItem value="Inter-2nd-Year">Inter-2nd-Year</MenuItem>
                     </Select>
                   </FormControl>
               
                   <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                     <InputLabel id="course-type-label">Select Course</InputLabel>
                     <Select
                       labelId="course-type-label"
                       value={selectedCourseType}
                       onChange={(e) => setSelectedCourseType(e.target.value)}
                       label="Select Course"
                       sx={{ height: 35 }}
                     >
                       {courseOptions.map((course, index) => (
                         <MenuItem key={index} value={course}>{course}</MenuItem>
                       ))}
                     </Select>
                   </FormControl>
               
                   <FormControl size="small" sx={{ minWidth: 120, marginRight: 2 }}>
                     <InputLabel id="intermediate-section-select-label">Select Section</InputLabel>
                     <Select
                       labelId="intermediate-section-select-label"
                       value={interSelectedSection}
                       onChange={(e) => setInterSelectedSection(e.target.value)}
                       label="Select Section"
                       sx={{ height: 35 }}
                     >
                       {interSectionOptions.map((section, index) => (
                         <MenuItem key={index} value={section}>{section}</MenuItem>
                       ))}
                     </Select>
                   </FormControl>
                 </>
               )}
  {/* Search Field */}
<TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{ width: 200 , ml: 1, height: 35}}
            />

  <Box sx={{ flexGrow: 1 }} />

<Button
                variant="contained"
                onClick={handleExportClick}
                style={{ backgroundColor: "#3C3972", fontWeight: "bold" }}
                startIcon={<PresentToAllIcon />}
              >
                Export
              </Button>

              <Menu
                anchorEl={exportAnchorEl}
                open={isExportMenuOpen}
                onClose={handleExportClose}
                sx={{
                  "& .MuiPaper-root": {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                  },
                }}
              >
                <MenuItem
                  onClick={exportToExcel}
                  sx={{
                    color: "#3f51b5",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#e8f0fe",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#00796b" }}>
                    <SimCardDownloadIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Excel"
                    sx={{ fontWeight: "bold", color: "#00796b" }}
                  />
                </MenuItem>

                <MenuItem
                  onClick={exportToPDF}
                  sx={{
                    color: "#d32f2f",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#fdecea",
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: "#d32f2f" }}>
                    <PictureAsPdfIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="PDF"
                    sx={{ fontWeight: "bold", color: "#d32f2f" }}
                  />
                </MenuItem>

              </Menu>
</Box>

<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />


<div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%" }}>
<div style={{
    width: "69%", // Adjusted width to fit alongside the table
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "5px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight:"300px"
  }}>
  {/* Table Section - Left */}
  <TableContainer component={Paper} sx={{
    borderRadius: 2,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    height: "300px",
    overflow: "auto",
    // width: "65%"  // Adjusted width to fit alongside pie chart
  }} className="custom-sidebar-scrollbar">
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:"bold",fontSize:"14px"}}>S.No</TableCell>
          {(board === "INTERMEDIATE" ) && (
                                                                                                    <TableCell
                                                                                                                                                                                          sx={{
                                                                                                                                                                                            borderRight: "1px solid #ddd",
                                                                                                                                                                                            padding: "4px",
                                                                                                                                                                                            textAlign: "center",
                                                                                                                                                                                            whiteSpace: "nowrap",
                                                                                                                                                                                            backgroundColor: "#fff9c4",
                                                                                                                                                                                            overflow: "hidden",
                                                                                                                                                                                            textOverflow: "ellipsis",
                                                                                                                                                                                            fontSize: "14px",
                                                                                                                                                                                            fontWeight: "bold",
                                                                                                                                                                                          }}
                                                                                                                                                                                          >
                                                                                                                                                                                            Course
                                                                                                     </TableCell>
                          )}
         <TableCell
                             sx={{
                               borderRight: "1px solid #ddd",
                               padding: "4px",
                               backgroundColor: "#fff9c4",
                               textAlign: "center",
                               fontSize: "14px",
                               fontWeight: "bold",
                             }}
                           >
                             {board === "INTERMEDIATE" ? "Year" : "Class"}
                           </TableCell>
          <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'bold',fontSize:"14px"}}>Section</TableCell>
          
          <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'bold',fontSize:"14px"}}>Roll No</TableCell>
          <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'bold',fontSize:"14px"}}>Student Name</TableCell>
          <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'bold',fontSize:"14px"}}>Marks</TableCell>
          <TableCell sx={{ border: "1px solid #ddd", padding: "4px", backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'bold',fontSize:"14px"}}>Grade</TableCell>
           <TableCell sx={{ borderRight: "1px solid #ddd",padding: "4px" ,backgroundColor: "#fff9c4", textAlign: "center",fontWeight:'bold',fontSize:"14px" }}>Full Details</TableCell>
        </TableRow>
      </TableHead>

      {loading ? (
        <TableBody>
          <TableRow>
             <TableCell
                                  colSpan={9}
                                  style={{ textAlign: "center", padding: "20px" }}
                                >
                                  <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                  >
                                    <CircularProgress />
                                    <Typography variant="body2" sx={{ mt: 1 }}>
                                      Loading Data...
                                    </Typography>
                                  </Box>
                                </TableCell>
          </TableRow>
        </TableBody>
      ) : filteredResults.length === 0 ? (
        <TableBody>
          <TableRow>
            <TableCell colSpan={9} sx={{ textAlign: "center" }}>
              Marks Not Uploaded
            </TableCell>
          </TableRow>
        </TableBody>
      ) : (
        <TableBody>
          {filteredResults.map((row, index) => (
            <TableRow key={row.admissionNumber} style={{ backgroundColor: "white", transition: "background-color 0.3s" }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#f5f5f5"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "white"; }}>

              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{index + 1}</TableCell>
               {board === "INTERMEDIATE" && (
                                                                                                                                                                            <TableCell
                                                                                                                                                                              sx={{
                                                                                                                                                                                borderRight: "1px solid #ddd",
                                                                                                                                                                                padding: "4px",
                                                                                                                                                                                textAlign: "center",
                                                                                                                                                                              }}
                                                                                                                                                                            >
                                                                                                                                                                              {row.course}
                                                                                                                                                                            </TableCell>
                                )}
              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.romanNumberClass}</TableCell>
              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.sections}</TableCell>
              
              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.studentRollNumber}</TableCell>
              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.firstName} {row.lastName}</TableCell>
              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.obtainedMarks}/{row.totalMarks}</TableCell>
              <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{row.overallGrade}</TableCell>
               <TableCell
                    sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}
                    >
                      <Button
                        type="button"
                        // onClick={() => navigate(`/Unit1ExaminationIndividualResultList/${Examtype}`, { state: { studentResults: row} })}
                          onClick={() => {
                              sessionStorage.setItem("studentResult", JSON.stringify(row));
                              navigate(`/Unit1ExaminationIndividualResultList/${Examtype}`);
                            }}                        sx={{
                          backgroundColor: "#1976d2",
                          color: "white",
                          fontSize: "0.6rem", // Reduces the font size
                          // padding: "5px 10px",  // Reduces the padding
                          height: "25px",       // Reduces the height
                          "&:hover": {
                            backgroundColor: "#1565c0",
                          },
                        }}
                      >
                        View
                      </Button>
                    </TableCell>
            </TableRow>
          ))}
        </TableBody>
      )}
    </Table>
  </TableContainer>
  </div>

  {/* Pie Chart Section - Right */}
  <div
      style={{
        width: "30%",
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "310px",
      }}
    >
      <Typography
        variant="h6"
        style={{
          fontWeight: "bold",
          textAlign: "center",
          marginBottom: "10px",
          color: "#333",
        }}
      >
        {board === "INTERMEDIATE"
          ? `${interSelectedClass}-${interSelectedSection}-Performance`
          : `${sscSelectedClass}-${sscSelectedSection}-Performance`}
      </Typography>

     

      {/* Pie Chart Below Legend */}
      <PieChart width={310} height={200}>
  {pieData.length > 0 && pieData.some((entry) => entry.value > 0) ? (
    <Pie
      data={pieData}
      dataKey="value"
      nameKey="name"
      cx="50%"
      cy="50%"
      outerRadius={80}
      label={({ name, percent }) =>
        percent > 0 ? ` ${(percent * 100).toFixed(0)}%` : "0%"
      }
    >
      {pieData.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={entry.color} />
      ))}
    </Pie>
  ) : (
    <text
      x="50%"
      y="50%"
      textAnchor="middle"
      dominantBaseline="middle"
      style={{ fontSize: "14px", fontWeight: "bold", fill: "#777" }}
    >
      No Data Available
    </text>
  )}
</PieChart>


       {/* Legend */}
       <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        {pieData.map((entry, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: entry.color,
                marginRight: "5px",
              }}
            ></div>
            <Typography variant="body2" style={{ color: "#333", fontWeight: "bold", fontSize: "12px" }}>
              {entry.name} ({entry.value}%)
            </Typography>
          </div>
        ))}
      </div>
    </div>
 
</div>

<ToastContainer position="top-right" autoClose={2000} />
        </CardContent>
      </Card>
    </Box>
  );
};

export default Unit1ExaminationResultList;